export enum SharedFilesType {
   WhoFor,
   SelectReciepent
  }
  